/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type PlayersControllerListPlayersV1Position = typeof PlayersControllerListPlayersV1Position[keyof typeof PlayersControllerListPlayersV1Position];


export const PlayersControllerListPlayersV1Position = {
  GK: 'GK',
  CB: 'CB',
  LB: 'LB',
  RB: 'RB',
  DM: 'DM',
  CM: 'CM',
  AM: 'AM',
  LW: 'LW',
  RW: 'RW',
  ST: 'ST',
} as const;
